import { useQuery } from "@apollo/client";
import { GET_BAND } from "../graphql";
import { useParams } from "react-router-dom";
import "react-image-crop/dist/ReactCrop.css";
import BandForm from "./form";
import { Band as BandType } from "../../../__generated__/graphql";
import { LoadingOverlay } from "../../../components/Loading";

const Band = () => {
  const { id } = useParams();
  const { data, loading, refetch } = useQuery(GET_BAND, {
    variables: {
      id: id!,
    },
    skip: !id,
  });

  const handleRefetch = (id: string) => {
    refetch({
      id: id,
    });
  };

  const isLoading = id !== undefined && !data?.band || loading

  return (
    <LoadingOverlay loading={isLoading}>
      <BandForm band={data?.band as BandType} refetch={handleRefetch} />
    </LoadingOverlay>
  );
};

export default Band;
